//---------------angular staff---------------
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { authInterceptorProviders } from './shared/interceptors/auth-token.interceptor';

//---------------components------------------------
import { AppComponent } from './app.component';

//-------------modules------------------------------
import { SupportFormModule } from './support-form/support-form.module';
import { SharedModule } from './shared/shared.module';
import { MaterialModule } from './material.module';
import { LoginModule } from './shared/components/login/login.module';
import { LoaderModule } from './shared/components/loader/loader.module';
import { MainModule } from './main/main.module';
import { SupprotChatBoxModule } from './supprot-chat/supprot-chat-box.module';
import { SignPageModule } from './sign-page/sign-page.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SupportFormModule,
    SharedModule,
    SupprotChatBoxModule,
    MaterialModule,
    LoginModule,
    LoaderModule,
    MainModule,
    SignPageModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    })
  ],
  providers: [authInterceptorProviders],
  bootstrap: [AppComponent],
})
export class AppModule {}
